import Result from "slotworks/model/gameplay/records/results/result";

export default class FreespinWinResult extends Result {

    /** For debugging purposes */
    public resultType: string = "FreespinWinResult";

    public freespinsWon: number;
}
